var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"side-menu-overlay",class:{ active: _vm.isActive },on:{"click":_vm.closeMenu}}),_vm._v(" "),_c('div',{staticClass:"side-menu-wrapper",class:{ isRight: _vm.isRight, active: _vm.isActive }},[_c('div',{staticClass:"menu-content",class:{ isRight: _vm.isRight}},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }